<template>
  <div>
  
      <vs-card>
        <form-wizard
          color="rgba(var(--vs-primary), 1)"
          :title="null"
          :subtitle="$t('UsageInfo')"
          :backButtonText="$t('Back')"
          :finishButtonText="$t('Submit')"
          :nextButtonText="$t('Next')"
          @on-complete="formSubmitted"
          v-if="steps.length > 0"
        >
          <tab-content
            class="mb-5"
            v-for="(item, index) in steps"
            :id="index"
            :key="index"
            ref="steps"
          >
            <b-row >
              <UsageViewImage
                :imageSrc="item.imageSrc"
                :markers="item.markers"
                :indexLc="index"								
								:imageWidth="'90%'"
              />
            </b-row>
          </tab-content>
        </form-wizard>
      </vs-card>
    
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import UsageViewImage from "./UsageViewImage.vue";
export default {
  props: {
    isSidebarActiveUsage: {
      type: Boolean,
      required: true,
    },
    steps: {
      default: () => {},
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  components: {
    UsageViewImage,
    FormWizard,
    TabContent,
  },
  methods: {
    formSubmitted() {
			this.$emit("closeUsageWizard");
		},
  },
  watch: {
    isSidebarActiveUsage(val) {
      return val;
    },
  },
  computed: {
    isUsageWizardPopup: {
      get() {
        return this.isSidebarActiveUsage;
      },
      set(val) {
        if (!val) {
          this.$emit("closeUsageWizard");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
};
</script>
<style lang="scss">
.vue-form-wizard.md .wizard-navigation .wizard-nav .wizard-icon-circle {
  width: 35px !important;
  height: 35px !important;
}
.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
  top: 25px !important;
}
</style>
